/* eslint-disable */

import { AddOn } from './AddOn';
import { AddOnType } from '../FbbEnum';
import { NortonOptionList, AddOnNortonPlan } from './AddOnNorton';

export class AddOnNortonVPN extends AddOn {
	protected selectedPlanList: Array<any> = [];
	protected maxPlanSelected: number = 1;
	protected planIndex: AddOnNortonPlan = AddOnNortonPlan.NONE; //Helen, please rename if needed
	protected plan: any = null;

	protected baseVasCode: String = 'VAS-NORTON';

	constructor() {
		super();
		this.key = 'AddOnNortonVPN';

		this.boxIconEn = '';
		this.boxIconZh = '';
		this.boxNameEn = 'Norton';
		this.boxNameZh = 'Norton';
		this.boxAmount = 30; //20
		this.hasRedCounter = false;

		this.type = AddOnType.SINGLE;
	}

	public getBaseVasCode(): String {
		return this.baseVasCode || '';
	}

	public isAddOnSelected(): boolean {
		return this.boxCount > 0;
	}

	public getPlanVasCode(): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			vasCode = this.getBaseVasCode() + '';
			return vasCode;
		} else {
			return '';
		}
	}
}
